/* eslint-disable */
import * as Types from '../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OnboardingFlowModalQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OnboardingFlowModalQuery = { viewer?: { __typename: 'Viewer', id: string, organisation: { __typename: 'ViewerOrganisation', id: string, title: string, website: string, fullLegalName: string, managingDirector: string, email: any, capabilities: Array<Types.Capabilities>, organisationType: Types.OrganisationType, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, billingAddress?: { __typename: 'Address', id: string, streetLines1: string, postalCode: string, city: string, countryCode: string } | null, offeredServices: Array<{ __typename: 'OrganisationOfferedService', categoryId: string, projectType: Types.OfferedProjectType }> } } | null };

export type OnboardingFlowModal_OrganisationDataPrefillQueryVariables = Types.Exact<{
  input: Types.OrganisationDataPrefillInput;
}>;


export type OnboardingFlowModal_OrganisationDataPrefillQuery = { organisationDataPrefill: { __typename: 'OrganisationDataPrefill', fullLegalName?: string | null, email?: string | null, phone?: string | null, managingDirector?: string | null, address?: { __typename: 'OrganisationDataPrefillAddress', city: string, postalCode: string, countryCode: string, streetLines1: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } };

export type OnboardingFlowModal_UpdateOrganisationMutationVariables = Types.Exact<{
  input: Types.OrganisationUpdateInput;
}>;


export type OnboardingFlowModal_UpdateOrganisationMutation = { updateOrganisation: { __typename: 'OrganisationUpdateResult', organisation: { __typename: 'ViewerOrganisation', id: string, title: string, website: string, fullLegalName: string, managingDirector: string, email: any, phones: Array<{ __typename: 'Phone', id: string, main: boolean, type: Types.PhoneType, number: string }>, billingAddress?: { __typename: 'Address', id: string, streetLines1: string, postalCode: string, city: string, countryCode: string } | null } } };

export type OnboardingFlowModal_SetOrganisationOfferedServicesMutationVariables = Types.Exact<{
  input: Types.SetOrganisationOfferedServicesInput;
}>;


export type OnboardingFlowModal_SetOrganisationOfferedServicesMutation = { setOrganisationOfferedServices: { __typename: 'OrganisationOfferedServiceMutationResult', organisation: { __typename: 'ViewerOrganisation', id: string, categories: Array<string>, offeredServices: Array<{ __typename: 'OrganisationOfferedService', categoryId: string, projectType: Types.OfferedProjectType }> } } };


export const OnboardingFlowModalDocument = gql`
    query OnboardingFlowModal {
  viewer {
    id
    organisation {
      id
      title
      website
      fullLegalName
      managingDirector
      email
      phones {
        id
        main
        type
        number
      }
      billingAddress {
        id
        streetLines1
        postalCode
        city
        countryCode
      }
      capabilities
      organisationType
      offeredServices {
        categoryId
        projectType
      }
    }
  }
}
    `;

/**
 * __useOnboardingFlowModalQuery__
 *
 * To run a query within a React component, call `useOnboardingFlowModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingFlowModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingFlowModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnboardingFlowModalQuery(baseOptions?: Apollo.QueryHookOptions<OnboardingFlowModalQuery, OnboardingFlowModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingFlowModalQuery, OnboardingFlowModalQueryVariables>(OnboardingFlowModalDocument, options);
      }
export function useOnboardingFlowModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingFlowModalQuery, OnboardingFlowModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingFlowModalQuery, OnboardingFlowModalQueryVariables>(OnboardingFlowModalDocument, options);
        }
export function useOnboardingFlowModalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OnboardingFlowModalQuery, OnboardingFlowModalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnboardingFlowModalQuery, OnboardingFlowModalQueryVariables>(OnboardingFlowModalDocument, options);
        }
export type OnboardingFlowModalQueryHookResult = ReturnType<typeof useOnboardingFlowModalQuery>;
export type OnboardingFlowModalLazyQueryHookResult = ReturnType<typeof useOnboardingFlowModalLazyQuery>;
export type OnboardingFlowModalSuspenseQueryHookResult = ReturnType<typeof useOnboardingFlowModalSuspenseQuery>;
export type OnboardingFlowModalQueryResult = Apollo.QueryResult<OnboardingFlowModalQuery, OnboardingFlowModalQueryVariables>;
export const OnboardingFlowModal_OrganisationDataPrefillDocument = gql`
    query OnboardingFlowModal_OrganisationDataPrefill($input: OrganisationDataPrefillInput!) {
  organisationDataPrefill(input: $input) {
    fullLegalName
    email
    phone
    managingDirector
    address {
      city
      postalCode
      countryCode
      streetLines1
      location {
        lat
        lng
      }
    }
  }
}
    `;

/**
 * __useOnboardingFlowModal_OrganisationDataPrefillQuery__
 *
 * To run a query within a React component, call `useOnboardingFlowModal_OrganisationDataPrefillQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingFlowModal_OrganisationDataPrefillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingFlowModal_OrganisationDataPrefillQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOnboardingFlowModal_OrganisationDataPrefillQuery(baseOptions: Apollo.QueryHookOptions<OnboardingFlowModal_OrganisationDataPrefillQuery, OnboardingFlowModal_OrganisationDataPrefillQueryVariables> & ({ variables: OnboardingFlowModal_OrganisationDataPrefillQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingFlowModal_OrganisationDataPrefillQuery, OnboardingFlowModal_OrganisationDataPrefillQueryVariables>(OnboardingFlowModal_OrganisationDataPrefillDocument, options);
      }
export function useOnboardingFlowModal_OrganisationDataPrefillLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingFlowModal_OrganisationDataPrefillQuery, OnboardingFlowModal_OrganisationDataPrefillQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingFlowModal_OrganisationDataPrefillQuery, OnboardingFlowModal_OrganisationDataPrefillQueryVariables>(OnboardingFlowModal_OrganisationDataPrefillDocument, options);
        }
export function useOnboardingFlowModal_OrganisationDataPrefillSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OnboardingFlowModal_OrganisationDataPrefillQuery, OnboardingFlowModal_OrganisationDataPrefillQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnboardingFlowModal_OrganisationDataPrefillQuery, OnboardingFlowModal_OrganisationDataPrefillQueryVariables>(OnboardingFlowModal_OrganisationDataPrefillDocument, options);
        }
export type OnboardingFlowModal_OrganisationDataPrefillQueryHookResult = ReturnType<typeof useOnboardingFlowModal_OrganisationDataPrefillQuery>;
export type OnboardingFlowModal_OrganisationDataPrefillLazyQueryHookResult = ReturnType<typeof useOnboardingFlowModal_OrganisationDataPrefillLazyQuery>;
export type OnboardingFlowModal_OrganisationDataPrefillSuspenseQueryHookResult = ReturnType<typeof useOnboardingFlowModal_OrganisationDataPrefillSuspenseQuery>;
export type OnboardingFlowModal_OrganisationDataPrefillQueryResult = Apollo.QueryResult<OnboardingFlowModal_OrganisationDataPrefillQuery, OnboardingFlowModal_OrganisationDataPrefillQueryVariables>;
export const OnboardingFlowModal_UpdateOrganisationDocument = gql`
    mutation OnboardingFlowModal_UpdateOrganisation($input: OrganisationUpdateInput!) {
  updateOrganisation(input: $input) {
    organisation {
      id
      title
      website
      fullLegalName
      managingDirector
      email
      phones {
        id
        main
        type
        number
      }
      billingAddress {
        id
        streetLines1
        postalCode
        city
        countryCode
      }
    }
  }
}
    `;
export type OnboardingFlowModal_UpdateOrganisationMutationFn = Apollo.MutationFunction<OnboardingFlowModal_UpdateOrganisationMutation, OnboardingFlowModal_UpdateOrganisationMutationVariables>;

/**
 * __useOnboardingFlowModal_UpdateOrganisationMutation__
 *
 * To run a mutation, you first call `useOnboardingFlowModal_UpdateOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardingFlowModal_UpdateOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardingFlowModalUpdateOrganisationMutation, { data, loading, error }] = useOnboardingFlowModal_UpdateOrganisationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOnboardingFlowModal_UpdateOrganisationMutation(baseOptions?: Apollo.MutationHookOptions<OnboardingFlowModal_UpdateOrganisationMutation, OnboardingFlowModal_UpdateOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardingFlowModal_UpdateOrganisationMutation, OnboardingFlowModal_UpdateOrganisationMutationVariables>(OnboardingFlowModal_UpdateOrganisationDocument, options);
      }
export type OnboardingFlowModal_UpdateOrganisationMutationHookResult = ReturnType<typeof useOnboardingFlowModal_UpdateOrganisationMutation>;
export type OnboardingFlowModal_UpdateOrganisationMutationResult = Apollo.MutationResult<OnboardingFlowModal_UpdateOrganisationMutation>;
export type OnboardingFlowModal_UpdateOrganisationMutationOptions = Apollo.BaseMutationOptions<OnboardingFlowModal_UpdateOrganisationMutation, OnboardingFlowModal_UpdateOrganisationMutationVariables>;
export const OnboardingFlowModal_SetOrganisationOfferedServicesDocument = gql`
    mutation OnboardingFlowModal_SetOrganisationOfferedServices($input: SetOrganisationOfferedServicesInput!) {
  setOrganisationOfferedServices(input: $input) {
    organisation {
      id
      categories
      offeredServices {
        categoryId
        projectType
      }
    }
  }
}
    `;
export type OnboardingFlowModal_SetOrganisationOfferedServicesMutationFn = Apollo.MutationFunction<OnboardingFlowModal_SetOrganisationOfferedServicesMutation, OnboardingFlowModal_SetOrganisationOfferedServicesMutationVariables>;

/**
 * __useOnboardingFlowModal_SetOrganisationOfferedServicesMutation__
 *
 * To run a mutation, you first call `useOnboardingFlowModal_SetOrganisationOfferedServicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardingFlowModal_SetOrganisationOfferedServicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardingFlowModalSetOrganisationOfferedServicesMutation, { data, loading, error }] = useOnboardingFlowModal_SetOrganisationOfferedServicesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOnboardingFlowModal_SetOrganisationOfferedServicesMutation(baseOptions?: Apollo.MutationHookOptions<OnboardingFlowModal_SetOrganisationOfferedServicesMutation, OnboardingFlowModal_SetOrganisationOfferedServicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardingFlowModal_SetOrganisationOfferedServicesMutation, OnboardingFlowModal_SetOrganisationOfferedServicesMutationVariables>(OnboardingFlowModal_SetOrganisationOfferedServicesDocument, options);
      }
export type OnboardingFlowModal_SetOrganisationOfferedServicesMutationHookResult = ReturnType<typeof useOnboardingFlowModal_SetOrganisationOfferedServicesMutation>;
export type OnboardingFlowModal_SetOrganisationOfferedServicesMutationResult = Apollo.MutationResult<OnboardingFlowModal_SetOrganisationOfferedServicesMutation>;
export type OnboardingFlowModal_SetOrganisationOfferedServicesMutationOptions = Apollo.BaseMutationOptions<OnboardingFlowModal_SetOrganisationOfferedServicesMutation, OnboardingFlowModal_SetOrganisationOfferedServicesMutationVariables>;